module.exports = "/img/6.3e3aac.webp";